import { getCookieValue, setCookieValue } from "./manageTablePersistence";

const PAGE_UI_PREFIX = "ws_pui_";

const sanitize = (k) => `${k}`.replace(/[^a-zA-Z0-9_-]/g, "_");
export const getPageUiCookieName = (pageId) => `${PAGE_UI_PREFIX}${sanitize(pageId)}`;

/**
 * @param {string} pageId
 * @returns {Record<string, unknown>|null}
 */
export const readPageUiObject = (pageId) => {
  try {
    const raw = getCookieValue(getPageUiCookieName(pageId));
    if (raw == null || String(raw).trim() === "") return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed === "object" && parsed !== null) return parsed;
  } catch (_e) {
    /* ignore */
  }
  return null;
};

/**
 * @param {string} pageId
 * @param {Record<string, unknown>} obj
 */
export const writePageUiObject = (pageId, obj) => {
  if (obj == null || typeof obj !== "object") return;
  setCookieValue(getPageUiCookieName(pageId), JSON.stringify(obj));
};
